import React, { Component } from 'react';
import PropTypes from "prop-types";

import { Graphics } from "./contents/Graphics";

// Styles
import './PowerSupply.scss';

export class PowerSupply extends Component {

  componentWillMount() {
    this.props.createPowerSupply({
      props: this.props.defaultProps,
    });
  }

    showPowerSupplyModal = () => {
        this.props.setModal({
            type: 'POWERSUPPLY_CONTROLS',
            size: 'inside',
            connect: this.props.id
          });
        this.props.showModal({display: true});
    }

    render() {
        return (
            <ul>
                <li
                    id="PowerSupply"
                    tabIndex={0}
                    // onClick={this.showPowerSupplyModal}
                    // onKeyDown={ (e)=>{if(e.keyCode === 13 || e.keyCode === 32) this.showPowerSupplyModal(e)} }
                    >
                    <div className="connections">
                      <div className="electrodes">
                        <div className="group">
                          <div className="electrode">
                            <div id={'PowerSupply_1_NegativeElectrode'} className="dropTarget">
                              <p aria-hidden="true" className="label" style={{display:"none"}}>Power Supply Anode</p>
                            </div>
                          </div>
                        </div>
                        <div className="group">
                          <div className="electrode">
                            <div id={'PowerSupply_1_PositiveElectrode'} className="dropTarget">
                              <p aria-hidden="true" className="label" style={{display:"none"}}>Power Supply Cathode</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <p aria-hidden="true" className="label">Power supply</p> */}
                    <Graphics id={this.props.id} />
                </li>
            </ul>
        )
    }
}
PowerSupply.propTypes = {
  createPowerSupply: PropTypes.func,
};

PowerSupply.defaultProps = {
};
